import api from "./api";
import { API_URL_VERSION } from "../constants/environment";
import { toSearchFilter } from "utils/utils";

export const ENDPOINT_PERSON = API_URL_VERSION + 'pessoas'
export const ENDPOINT_PERSON_LIST = API_URL_VERSION + 'pessoas/listar'
export const ENDPOINT_PERSON_GET_UPDATE_DETAILS = API_URL_VERSION + 'pessoas/'

export const personsService = {
    list: async (params = {}) => {
        try {
            const searchParams = toSearchFilter(params);
            const response = await api.post(ENDPOINT_PERSON_LIST, searchParams);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "settings.person.messages.errors.list";
        }
    },

    findMany: async (params = {}) => {
        try {
            const searchParams = toSearchFilter(params);
            const response = await api.get(ENDPOINT_PERSON, { params: searchParams });
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "settings.person.messages.errors.find";
        }
    },

    create: async (data) => {
        try {
            const response = await api.post(ENDPOINT_PERSON, data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.erros_validacao || "settings.person.messages.errors.create";
        }
    },    

    find: async (id) => {
        try {
            const response = await api.get(`${ENDPOINT_PERSON_GET_UPDATE_DETAILS}${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "settings.person.messages.errors.list";
        }
    },

    update: async (id, data) => {
        try {
            const response = await api.put(`${ENDPOINT_PERSON_GET_UPDATE_DETAILS}${id}`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.erros_validacao || "settings.person.messages.errors.update";
        }
    },

    delete: async (id) => {
        try {
            const response = await api.delete(`${ENDPOINT_PERSON_GET_UPDATE_DETAILS}${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "settings.person.messages.errors.delete";
        }
    },

};
